import React from 'react';
import PropTypes from 'prop-types';
import FormControl from "../FormControl";

var FormFieldComponent = function FormFieldComponent(_ref) {
  var children = _ref.children,
      input = _ref.input,
      label = _ref.label,
      info = _ref.info,
      className = _ref.className,
      meta = _ref.meta,
      _ref$input = _ref.input,
      name = _ref$input.name,
      inputValue = _ref$input.value,
      inputChecked = _ref$input.checked,
      style = _ref.style,
      jss = _ref.jss,
      required = _ref.required;

  var onChangeValue = function onChangeValue() {
    var _children$props = children.props,
        onChange = _children$props.onChange,
        onSelect = _children$props.onSelect;

    if (onChange) {
      onChange.apply(void 0, arguments);
    }

    if (onSelect) {
      onSelect.apply(void 0, arguments);
    }

    input.onChange.apply(input, arguments);
  };

  var handleFocus = function handleFocus() {
    input.onFocus();
  };

  var handleBlur = function handleBlur() {
    input.onBlur();
  };

  var disabled = children.props.disabled;
  var error = meta.error,
      submitError = meta.submitError,
      modifiedSinceLastSubmit = meta.modifiedSinceLastSubmit,
      touched = meta.touched,
      active = meta.active;
  var showSubmitError = submitError && !modifiedSinceLastSubmit;
  var showValidationError = error && touched && !active;
  var validationErrorMessage = showValidationError ? error : '';
  var submitErrorMessage = showSubmitError ? submitError : '';
  var errorMessage = validationErrorMessage || submitErrorMessage;
  return /*#__PURE__*/React.createElement(FormControl, {
    info: info,
    error: errorMessage,
    label: label,
    onFocus: handleFocus,
    onBlur: handleBlur,
    className: className,
    style: style,
    name: name,
    required: required,
    jss: jss,
    "data-qa": "form-field-component"
  }, /*#__PURE__*/React.cloneElement(children, {
    disabled: disabled,
    onChange: onChangeValue,
    value: inputValue,
    checked: inputChecked
  }));
};

FormFieldComponent.defaultProps = {
  className: '',
  label: null,
  info: null,
  style: {},
  jss: {},
  required: false
};
FormFieldComponent.propTypes = {
  children: PropTypes.node.isRequired,
  required: PropTypes.bool,
  label: PropTypes.string,
  info: PropTypes.string,
  jss: PropTypes.oneOfType([PropTypes.shape(), PropTypes.func]),
  className: PropTypes.string,
  style: PropTypes.shape(),
  input: PropTypes.shape().isRequired,
  meta: PropTypes.shape().isRequired
};
FormFieldComponent.displayName = 'FormFieldComponent';
export default FormFieldComponent;